import {zodResolver} from '@hookform/resolvers/zod';
import {CircularProgress} from '@mui/material';
import {type ReactNode, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {z} from 'zod';
import OffBoardingForm from '@/components/OffBoarding/OffBoardingForm.tsx';
import DisplayIssues from '@/components/OnBoarding/DisplayIssues.tsx';
import {type IssueCreateResponse, useCreateOffboarding} from '@/Hooks/useCreateIssue.ts';

export type FieldValues = {
    firstName: string;
    lastName: string;
};

const offBoardingSchema = z.object({
    firstName: z.string().min(1, {message: 'First Name is required'}),
    lastName: z.string().min(1, {message: 'Last Name is required'}),
});

export type OffBoardingSchemaType = z.infer<typeof offBoardingSchema>;

const OnBoarding = (): ReactNode => {
    const [running, setRunning] = useState<boolean>(false);
    const [issues, setIssues] = useState<IssueCreateResponse[]>([]);
    const form = useForm<FieldValues, unknown, OffBoardingSchemaType>({
        resolver: zodResolver(offBoardingSchema),
    });
    const createIssues = useCreateOffboarding();

    return (
        <FormProvider {...form}>
            <form
                onSubmit={form.handleSubmit(async data => {
                    setIssues([]);
                    setRunning(true);
                    createIssues(data)
                        .then(issues => {
                            setIssues(issues);
                            form.reset();
                        })
                        .finally(() => setRunning(false));
                })}
            >
                <OffBoardingForm />
            </form>
            {running && <CircularProgress />}
            {issues && <DisplayIssues issues={issues} offBoarding={true} />}
        </FormProvider>
    );
};

export default OnBoarding;
